(function () {
    'use strict';
    var controllerId = '4a_pcAllievoAdd';
    angular.module('app').controller(controllerId, ['$scope', '$uibModalInstance', '$uibModal', 'datacontext', 'allievo', 'corsoId', 'opInsert', 'province', 'paesi', 'tIndirizzi', 'enti1', 'enti2', 'tMisuraCode', fn_4a_pcAllievoAdd]);

    function fn_4a_pcAllievoAdd($scope, $uibModalInstance, modal, datacontext, allievo, corsoId, opInsert, province, paesi, tIndirizzi, enti1, enti2, tMisuraCode) {
        //nascita
        $scope.province = province;
        $scope.paesi = paesi;
        $scope.comuni = [];
        //residenza
        $scope.province_res = province;
        $scope.paesi_res = paesi;
        $scope.comuni_res = [];
        $scope.tIndirizzi = tIndirizzi;
        //***
        $scope.enti1 = enti1;
        $scope.enti2 = enti2;
        $scope.validCF = true;
        $scope.checkCF = checkCF;
        //
        $scope.tMisuraCode = tMisuraCode;

        if (allievo) {
            $scope.record = jQuery.extend({}, allievo); //Clona oggetto.
            $scope.Title = 'Modifica Allievo (ID: ' + $scope.record.Id + ')';
            if (typeof $scope.record.CodiceFiscale != 'undefined' && $scope.record.CodiceFiscale != null && $scope.record.CodiceFiscale.length > 0) {
                checkCF($scope.record.CodiceFiscale);
            }
            if (typeof $scope.record.PartitaIVA != 'undefined' && $scope.record.PartitaIVA != null && $scope.record.PartitaIVA.length > 0) {
                checkPIVA($scope.record.PartitaIVA);
            }
            if ($scope.record.NascProvinciaId > 0) {
                getComuni($scope.record.NascProvinciaId);
            }
            if ($scope.record.ResProvinciaId > 0) {
                getResComuni($scope.record.ResProvinciaId);
            }
            if ($scope.record.NascData != null) {
                $scope.record.NascData = new Date($scope.record.NascData);
            }
        }
        else {
            $scope.Title = 'Nuovo Allievo';
            $scope.record = {};
            $scope.record.Id = 0;
            $scope.record.CNDCorsoId = corsoId;
            $scope.record.OpInsert = opInsert;
            $scope.record.Deleted = false;
            $scope.record.iVersion = 1;
            $scope.record.TMisuraCode = tMisuraCode;

            $scope.record.NascComuneId = '';
            $scope.record.NascPaeseId = 0;

            $scope.record.ResComuneId = '';
            $scope.record.ResPaeseId = 0;
            $scope.record.ResTIndirizzoId = 1;
            $scope.record.DestinatarioId = 0;

            if ($scope.record.DestinatarioId == 0) {
                addDestMis4A();
            }
        }

        function addDestMis4A() {
            var modalInstance = modal.open({
                templateUrl: '/app/CND/CNDPCorsi4A/modal/4a_destMisuraAdd.html?version=127',
                controller: '4a_destMisuraAdd',
                backdrop: 'static',
                resolve: {
                }
            });
            modalInstance.result.then(function (returnItem) {
                if (returnItem) {
                    //console.info('addDestMis4A()', returnItem);
                    setDestinatarioInfo(returnItem);
                }
            }, function () {
                $uibModalInstance.dismiss('cancel');
            });
        }

        function setDestinatarioInfo(item) {
            $scope.record.DestinatarioId = item.Id;
            $scope.record.Nome = item.Nome;
            $scope.record.Cognome = item.Cognome;
            $scope.record.CodiceFiscale = item.CodiceFiscale;
            $scope.record.NascPaeseId = item.NascPaeseId;
            if (item.NascProvId > 0) {
                $scope.record.NascProvinciaId = item.NascProvId;
                getComuni($scope.record.NascProvinciaId);
            }
            $scope.record.NascComuneId = item.NascComuneId;
            if (item.NascData != null) {
                $scope.record.NascData = new Date(item.NascData);
            }
            $scope.record.ResPaeseId = item.Res_PaeseId;
            if (item.Res_ProvinciaId > 0) {
                $scope.record.ResProvinciaId = item.Res_ProvinciaId;
                getResComuni($scope.record.ResProvinciaId);
            }
            $scope.record.ResComuneId = item.Res_ComuneId;
            $scope.record.ResTIndirizzoId = item.Res_TIndirizzoId;
            $scope.record.ResIndirizzo = item.Res_Indirizzo;
            $scope.record.ResCivico = item.Res_Civico;
            $scope.record.ResCAP = item.Res_Cap;
        }

        //Impostazioni per calendario dateTimePicker
        $scope.datepickers = {};
        $scope.today = function () {
            $scope.dt = new Date();
        };
        $scope.today();

        $scope.clear = function () {
            $scope.dt = null;
        };

        // Disable weekend selection
        $scope.disabled = function (date, mode) {
            //return (mode === 'day' && (date.getDay() === 0 || date.getDay() === 6));
        };

        $scope.toggleMin = function () {
            $scope.minDate = $scope.minDate ? null : new Date();
        };
        $scope.toggleMin();
        $scope.dateOptions = {
            formatYear: 'yyyy',
            formatMonth: 'MM',
            startingDay: 1
        };

        $scope.openCalendar = function ($event, iOpened) {
            console.log('openCalendar');
            $event.preventDefault();
            $event.stopPropagation();

            $scope.opened1 = false;
            if (iOpened == 1) {
                console.log('iOpened == 1');
                $scope.opened1 = true;
            }

        };

        $scope.clear = function ($event, iOpened) {
            console.log('clear');
            if (iOpened == 1) {
                $scope.record.NascData = '';
                $scope.changed = true;
            }

        };

        $scope.format = "dd/MM/yyyy";



        $scope.ok = function (isValid) {
            if (isValid) {
                var result = addItem($scope.record);
                $uibModalInstance.close(result);
            }
        };

        $scope.cancel = function () {
            $uibModalInstance.dismiss('cancel');
        };

        function addItem(item) {
            return item;
        }

        //nascita
        $scope.change_Paesi = function () {
            if ($scope.record.NascPaeseId > 0) {
                $scope.record.NascProvinciaId = 0;
                $scope.record.NascComuneId = 0;
            }
        };

        $scope.change_Comuni = function (idprov) {
            //console.info('change_Comuni()', idprov);
            $scope.record.NascComuneId = '';
            getComuni(idprov);
        };

        function getComuni(idprov) {
            //console.info('getComuni()', idprov);
            if (!idprov || idprov == 0) return $scope.comuni = [];

            if ($scope.record.NascProvinciaId != idprov)
                $scope.comuni = [];

            return datacontext.istat_comune_getAllList(idprov).then(function (data) {
                return $scope.comuni = data;
            });
        }

        //Residenza
        $scope.change_ResPaesi = function () {
            if ($scope.record.ResPaeseId > 0) {
                $scope.record.ResProvinciaId = 0;
                $scope.record.ResComuneId = 0;
            }
        };

        $scope.change_ResComuni = function (idprov) {
            //console.info('change_ResComuni()', idprov);
            $scope.record.ResComuneId = '';
            getResComuni(idprov);
        };

        function getResComuni(idprov) {
            //console.info('getResComuni()', idprov);
            if (!idprov || idprov == 0) return $scope.comuni_res = [];

            if ($scope.record.ResProvinciaId != idprov)
                $scope.comuni_res = [];

            return datacontext.istat_comune_getAllList(idprov).then(function (data) {
                return $scope.comuni_res = data;
            });
        }


        //Funzioni
        function checkCF(_value) {
            $scope.validCF = true;
            if (typeof _value == 'undefined') return;
            if (_value.length != 16) return;
            $scope.validCF = false;
            return datacontext.validazione_cf(_value, false).then(function (data) {
                return $scope.validCF = data;
            });
        }

    }
})();